import { render } from "./CampaignLandingView.vue?vue&type=template&id=5e95cb56&scoped=true"
import script from "./CampaignLandingView.vue?vue&type=script&lang=js"
export * from "./CampaignLandingView.vue?vue&type=script&lang=js"

import "./CampaignLandingView.vue?vue&type=style&index=0&id=5e95cb56&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e95cb56"]])

export default __exports__